<!-- 测评结果卡片 -->
<template>
  <div
    class="container sharePage"
    @touchstart="handleTouchStart"
    @touchend="handleTouchEnd"
    :style="{
      background: `url(${bgImageUrl})`,
      'background-repeat': 'no-repeat',
      'background-size': '100% auto',
      'background-position': '0 -100px',
      paddingTop: platform == 'app' ? `${statusBarHeight}vw` : 0,
    }"
  >
    <div class="navigator" v-if="platform == 'app'">
      <div class="back_share">
        <img
          class="back_img"
          src="@/assets/images/result/back.png"
          @click="back()"
          @touchmove.stop.prevent
          alt
        />
      </div>
    </div>
    <div class="page_content">
      <img
        class="logo_img"
        src="@/assets/images/share/logo.png"
        alt=""
        srcset=""
      />
      <img
        class="title_img"
        src="@/assets/images/share/title.png"
        alt=""
        srcset=""
      />
      <img
        class="sub_title_img"
        src="@/assets/images/share/sub_title.png"
        alt=""
        srcset=""
      />
      <div class="dot_box">
        <img
          v-for="(dot, iIdx) in dotsList"
          :key="iIdx"
          :src="dot.imgUrl"
          alt=""
          srcset=""
          class="dot_img"
          :class="[activeIndex === iIdx ? 'active' : '']"
        />
      </div>
    </div>
    <div
      class="footer_box"
      :style="{
        background: `url(${footerImageUrl})`,
        'background-repeat': 'no-repeat',
        'background-size': '100% auto',
        'background-position': 'bottom',
      }"
    >
      <!-- <img class="footer_img" src="@/assets/images/share/bottom.png" alt="" srcset=""> -->
      <div class="result_content">
        <div class="dots">
          <div
            class="dot_item"
            v-for="(dot, dIdx) in dotsList"
            :key="dIdx"
            :class="[activeIndex === dIdx ? 'active' : '']"
          ></div>
        </div>
        <van-button id="downbtn" type="default" class="btn_item"
          >打开大有阳光心理APP</van-button
        >
        <div class="protocol">
          <div @click="toProtocol('no3')">《隐私保护政策》</div>
          <div @click="toProtocol('no2')">《用户服务协议》</div>
        </div>
        <div class="company">
          开发者：广州大有网络科技有限公司
        </div>
        <div class="tips">
          *实际信息以下载版为准
        </div>
      </div>
    </div>
    <div class="develop_log" :class="isDev === 'development' ? 'dev_env' : ''">
      <div class="section">
        <b>分享参数:</b><br />
        <pre>
          {{ paramsData }}
        </pre>
      </div>
      <div class="section">
        <b>下发方案:</b><br />
        <pre id="J_solutionBox"></pre>
      </div>
    </div>
  </div>
</template>
<script>
import { getResult } from "@/api/result";
export default {
  data() {
    // 这里存放数据
    return {
      bannerTimer: null,
      isDev: process.env.VUE_APP_ENV,
      bgImageUrl: require("@/assets/images/share/bg.png"),
      footerImageUrl: require("@/assets/images/share/bottom.png"),
      id: "",
      type: "",
      title: "",
      resultData: {},
      resultTime: "",
      paramsData: {},
      dotsList: [
        {
          imgUrl: require("@/assets/images/share/banner_1.png"),
        },
        {
          imgUrl: require("@/assets/images/share/banner_2.png"),
        },
        {
          imgUrl: require("@/assets/images/share/banner_3.png"),
        },
        {
          imgUrl: require("@/assets/images/share/banner_4.png"),
        },
        {
          imgUrl: require("@/assets/images/share/banner_5.png"),
        },
        {
          imgUrl: require("@/assets/images/share/banner_6.png"),
        },
      ],
      activeIndex: 0,
      touchStartX: 0,
      touchEndX: 0,
    };
  },
  methods: {
    toProtocol(path) {
      this.$router.push({
        path,
      });
    },
    handleTouchStart(event) {
      this.touchStartX = event.touches[0].clientX;
    },
    handleTouchEnd(event) {
      this.touchEndX = event.changedTouches[0].clientX;
      this.handleSlide();
    },
    handleSlide() {
      const diff = this.touchEndX - this.touchStartX;
      if (diff > 50) {
        // 向右滑动,看左边
        if (this.activeIndex > 0) {
          this.activeIndex = Math.max(this.activeIndex - 1, 0);
        } else {
          this.activeIndex = this.dotsList.length - 1;
        }
      } else if (diff < -50) {
        // 向左滑动,看右边
        if (this.activeIndex < this.dotsList.length - 1) {
          this.activeIndex += 1;
          this.clearBannerTimer();
          this.setBannerTimer();
        } else {
          this.activeIndex = 0;
          this.clearBannerTimer();
          this.setBannerTimer();
        }
      }
    },
    setBannerTimer() {
      // 设置一个定时器,轮播banner
      this.bannerTimer = setInterval(() => {
        if (this.activeIndex === this.dotsList.length - 1) {
          this.activeIndex = 0;
        } else {
          this.activeIndex++;
        }
      }, 5000);
    },
    clearBannerTimer() {
      if (this.bannerTimer) {
        clearInterval(this.bannerTimer);
      }
    },
    back() {
      this.bridgeClose();
    },
    createULink() {
      const ULink = window.ULink;
      console.log("---ULink", ULink);

      const url = (window.location.href || "").split("?")[1];
      // const data = ULink.getUriParams(url);
      const data = ULink.getUriDecodeParams(url);
      if (data.hasOwnProperty("params")) {
        data.params = JSON.parse(data.params);
      }
      console.log("---ULink--data", data);
      ULink([
        {
          // id: data.linkId,
          id: "usr1jvrml77haac0", // 后台生成的裂变活动LinkID
          data: data,
          selector: "#downbtn", // id名字,需要与页面内跳转按钮的id一致
          auto: false, // 含义见下文,
          lazy: false,
          useOpenInBrowerTips: "default", // 在微信等内打开会提示去浏览器
          proxyOpenDownload(defaultAction, LinkInstance) {
            if (LinkInstance.solution.type === "scheme") {
              if (ULink.isWechat || ULink.isQQ) {
                defaultAction();
              } else {
                window.location.href = LinkInstance.solution.downloadUrl;
              }
            }
          },
          onready: function(ctx) {
            console.log("ready", ctx);
            document.getElementById("J_solutionBox").innerText = JSON.stringify(
              ctx.solution,
              null,
              2
            );
          },
        },
      ]);
    },
  },
  created() {},
  mounted() {
    if (this.$route.query.url) {
      console.log("---url", this.$route.query.url);
      const url = decodeURI(this.$route.query.url);
      this.$router.replace({
        path: url,
        // query: {
        //   id: this.id,
        //   type: this.type,
        //   reportId: this.infoData.latestAnswerId,
        // },
      });
    } else {
      this.createULink();
    }
    this.id = this.$route.query.id;
    this.reportId = this.$route.query.reportId;
    this.type = this.$route.query.type;
    this.title = this.$route.query.title;
    let nowTime = new Date();
    let year = nowTime.getFullYear();
    let month = nowTime.getMonth() + 1;
    let day = nowTime.getDate();
    let hour = nowTime.getHours();
    let minute = nowTime.getMinutes();
    this.resultTime = `${year}/${month}/${day}/ ${hour}:${minute}`;

    this.setBannerTimer();
  },
};
</script>
<style lang="scss" scoped>
// @import "~@/styles/variable.scss";
.container {
  color: #333333;
  // height: 100vh;
  background-color: #f3f4f6;
}
.sharePage {
  display: flex;
  overflow-y: auto;
  /* padding: 80px 24px 24px 24px; */
  .navigator {
    width: 100vw;
    height: 85px;
    color: #292929;
    padding: 25px 30px;
    /* position: fixed; */
    top: 0px;
    left: 0;
    z-index: 9;
    text-align: center;
    .back_share {
      width: 100%;
      .back_img {
        width: 21px;
        height: 38px;
        float: left;
      }
    }
  }
  .page_content {
    position: fixed;
    top: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100vw;
    text-align: center;
    padding: 0 42px;
    .logo_img {
      margin-top: 80px;
      width: 138px;
      height: 138px;
    }
    .title_img {
      margin-top: 18px;
      width: 138px;
      height: 34px;
    }
    .sub_title_img {
      margin-top: 16px;
      width: 282px;
      height: 25px;
    }
    .result_img {
      width: 600px;
      min-height: 800px;
      margin-top: 50px;
    }
    .result_type_box {
      margin: 0 auto;
      margin-top: 150px;
      width: fit-content;
      .result_type_top {
        position: relative;
        display: inline-block;
        padding: 20px 0px 0px 20px;
        .result_icon {
          width: 59px;
          height: 22px;
          position: absolute;
          top: 0;
          right: -24px;
        }
        .result_type {
          font-family: PingFang SC;
          font-weight: bold;
          font-size: 30px;
          color: #ffffff;
        }
      }
      .result_type_bottom {
        position: relative;
        padding: 0px 20px 20px 30px;
        .result_subtitle {
          font-family: Alimama ShuHeiTi;
          font-weight: bold;
          font-size: 51px;
          color: #ffffff;
        }
        .left_icon {
          width: 53px;
          height: 30px;
          position: absolute;
          left: 0px;
          bottom: 0;
        }
      }
    }
  }
}

.dot_box {
  -webkit-transform: translateZ(0);
  /* position: fixed; */
  display: flex;
  margin-top: 113px;
  width: 539px;
  height: 708px;
  /* bottom: 322px; */
  .dot_img {
    -webkit-transform: translateZ(0);
    position: fixed;
    /* left: 0; */
    /* bottom:200px; */
    width: 539px;
    height: 708px;
    opacity: 0;
    transition: opacity 0.5s ease-in-out;
    &.active {
      opacity: 1;
    }
  }
}
.footer_box {
  position: fixed;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 515px;
  .footer_img {
    object-fit: cover;
  }
  .result_content {
    text-align: center;
    margin-top: 110px;
    #downbtn {
      margin-bottom: 34px;
    }
    .btn_item {
      width: 574px;
      height: 104px;
      background: linear-gradient(90deg, #79e695, #5ad8b7);
      border-radius: 50px;
      font-family: PingFang SC;
      font-weight: bold;
      font-size: 38px;
      color: #ffffff;
      text-align: center;
      line-height: 88px;
      /* margin-top: 53px; */
      border: none;
    }
    .protocol {
      display: flex;
      justify-content: center;
      width: 100%;
      text-align: center;
      font-family: PingFang SC;
      font-weight: 500;
      font-size: 24px;
      color: #60dbb0;
      line-height: 36px;
      margin-bottom: 38px;
    }
    .company {
      margin: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      font-size: 24px;
      color: #222222;
      line-height: 36px;
    }
    .tips {
      font-family: PingFang SC;
      font-weight: 500;
      font-size: 20px;
      color: #999999;
      line-height: 36px;
    }
    .dots {
      display: flex;
      justify-content: center;
      padding: 26px;
      .dot_item {
        width: 16px;
        height: 16px;
        background: rgba(119, 229, 151, 0.2);
        border-radius: 50%;
        margin: 0 8px;
        &.active {
          background: #77e597;
        }
      }
    }
  }
}
.develop_log {
  top: 20%;
  width: 100%;
  display: none;
  position: absolute;
  padding: 20px;
  &.dev_env {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .section {
    width: 100%;
  }
}
</style>
